import React from 'react';
import { maxWidthContainer } from '@noths/polaris-client-ribbons-base';
import { visuallyHidden } from '@noths/polaris-client-styles';

import { BackToTopButton } from 'src/components/molecules/BackToTopButton/BackToTopButton';
import { MembershipBannerSection } from 'src/components/molecules/MembershipBannerSection/MembershipBannerSection';
import { ProductListError } from 'src/components/molecules/ProductListError/ProductListError';
import { SearchHeader } from 'src/components/molecules/SearchHeader/SearchHeader';
import { ListingsControlsDrawerContainer } from 'src/components/organisms/ListingsControlsDrawer/ListingsControlsDrawerContainer';
import { useFilterNavType } from 'src/hooks/useFilterNavType/useFilterNavType';
import { actions as navigationActions } from 'src/redux/navigation/slice';
import { useStore } from 'src/redux/store';
import * as styles from 'src/styles/pages.styles';
import type { PageProps } from 'src/types/page';
import { ListingsLayout } from '../ListingLayout/ListingsLayout';
import { NoSearchResults } from '../NoSearchResults/NoSearchResults';

export type SearchListingProps = PageProps & {
  pageLiveRegionText: string;
  searchTerm: string;
};

export const SearchListing = ({
  pageLiveRegionText,
  products,
  searchTerm,
  showProductsList,
}: SearchListingProps) => {
  const { dispatch } = useStore();

  useFilterNavType((navType) => dispatch(navigationActions.setInitialPageLoad(navType)));

  return (
    <>
      <div css={visuallyHidden} role="status">
        {pageLiveRegionText}
      </div>
      <div css={styles.wrapper}>
        <div css={maxWidthContainer}>
          <SearchHeader searchTerm={searchTerm} />
        </div>
        {showProductsList ? (
          <ListingsLayout>
            <MembershipBannerSection trackingLocation="search" />
            <BackToTopButton />
            <ListingsControlsDrawerContainer />
          </ListingsLayout>
        ) : products.error ? (
          <ProductListError message={products.error.message} />
        ) : (
          <NoSearchResults searchTerm={searchTerm} />
        )}
      </div>
    </>
  );
};
